import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Content } from 'rsuite';
import { createROItem } from '../../../../redux/Reservation/sagas/routines';
import {
  getIsSaving,
  getIsSaved
} from '../../../../redux/Reservation/selectors/routes/ro-item/create';
import { modifyAccess } from '../../../../helpers/permission';
import * as PERMISSIONS from '../../../../constants/permissions/reservation';
import PageHeader from '../../../../components/PageHeader';
import PageLayout from '../../../../components/reservations/PageLayout';
import ROItemForm from '../../../../components/reservations/ROItemForm';
import AccessControl from '../../../../components/AccessControl';
import AccessDenied from '../../../../components/AccessDenied';
import { reservationsROItemListPath } from '../../../Paths';
import Breadcrumb from '../../../../components/Breadcrumb';

export default () => {
  const dispatch = useDispatch();
  const isSaving = useSelector(getIsSaving);
  const isSaved = useSelector(getIsSaved);
  const handleSubmit = body => {
    dispatch(createROItem({ body }));
  };

  return (
    <PageLayout>
      <AccessControl
        allowOnlyFor={modifyAccess(PERMISSIONS.RO_ITEM)}
        fallback={<AccessDenied />}
      >
        <Breadcrumb
          items={[
            {
              path: reservationsROItemListPath,
              label: 'Items'
            },
            { label: `Create Item` }
          ]}
        />

        <PageHeader title="Create Item" />
        <Content style={{ marginTop: 0 }}>
          <ROItemForm
            onSubmit={handleSubmit}
            isSaving={isSaving}
            isSaved={isSaved}
          />
        </Content>
      </AccessControl>
    </PageLayout>
  );
};
